"use strict";
/*
 * Created on 09 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../../core/model/errors/conversions/ValidationResultConverter");

var SiteReleaseTerminationUploadedItem_1 = require("../../model/price-termination/SiteReleaseTerminationUploadedItem");

var SiteReleaseTerminationUploadedItemConverter_1 = require("./SiteReleaseTerminationUploadedItemConverter");
/**
 * @author Jaroslav Sevcik
 */


var SiteReleaseTerminationUploadedItemConverterImpl =
/*#__PURE__*/
function (_SiteReleaseTerminati) {
  _inherits(SiteReleaseTerminationUploadedItemConverterImpl, _SiteReleaseTerminati);

  function SiteReleaseTerminationUploadedItemConverterImpl(validationResultConverter) {
    var _this;

    _classCallCheck(this, SiteReleaseTerminationUploadedItemConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseTerminationUploadedItemConverterImpl).call(this));
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SiteReleaseTerminationUploadedItemConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        uploadId: conversions.toDocumentReferenceId(source.uploadId),
        pExtId: source.pExtId,
        gosExtId: source.gosExtId,
        endDate: conversions.asObjectOpt(source, 'endDate', function (v) {
          return conversions.fromDate(v);
        }),
        rowNumber: source.rowNumber,
        uploaded: conversions.fromDate(source.uploaded),
        validation: this.validationResultConverter.toDocument(source.validation, conversions)
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SiteReleaseTerminationUploadedItem_1.SiteReleaseTerminationUploadedItem(conversions.documentToClassId(source), conversions.asObject(source, 'uploadId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectOpt(source, 'pExtId', function (v) {
        return v;
      }), conversions.asObjectOpt(source, 'gosExtId', function (v) {
        return v;
      }), conversions.asObjectOpt(source, 'endDate', function (v) {
        return conversions.toDate(v);
      }), conversions.asObject(source, 'rowNumber', function (v) {
        return v;
      }), conversions.asObject(source, 'uploaded', function (v) {
        return conversions.toDate(v);
      }), conversions.asObject(source, 'validation', function (doc) {
        return _this2.validationResultConverter.toObject(doc, conversions);
      }));
    }
  }]);

  return SiteReleaseTerminationUploadedItemConverterImpl;
}(SiteReleaseTerminationUploadedItemConverter_1.SiteReleaseTerminationUploadedItemConverter);

SiteReleaseTerminationUploadedItemConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultConverter_1.ValidationResultConverter])], SiteReleaseTerminationUploadedItemConverterImpl);
exports.SiteReleaseTerminationUploadedItemConverterImpl = SiteReleaseTerminationUploadedItemConverterImpl;